import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import Gallery from './prod/Gallery';
import TabSwitcher from './utils/TabSwitcher';
import HeaderScroll from './utils/HeaderScroll';
import { RunCommon } from './common/run';
import Share from './prod/Share';
import Swiper, { Navigation } from 'swiper';
import Order from './prod/Order';
import Print from './prod/Print';
import CallbackForm from './utils/CallbackForm';
import { initTooltips } from './common/tooltip';
import { initShowParams } from './prod/showParams';
import { trackFav, trackCompare, trackShare } from './prod/fav';
import HeaderFixed from './prod/HeaderFixed';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';
import { BUILT_SLID_BP, THUMBS_SLID_BP } from './const';
import {
  extraProdsWithCategories,
  extraProds,
} from './common/cmpt/prodItem/ExtraProds';

RunCommon();

initShowParams();

HeaderScroll();

initTooltips();

if (window.gallery.length > 0) {
  const node = document.getElementById('prod-gallery');
  const root = ReactDOM.createRoot(node);
  root.render(
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <React.StrictMode>
          <Suspense fallback={<></>}>
            <Gallery
              items={window.gallery}
              breakpoints={THUMBS_SLID_BP}
              video={window.video}
            />
          </Suspense>
        </React.StrictMode>
      </PersistGate>
    </Provider>,
  );
}

const prod = window.prodJSON;

const node = document.getElementById('order-section');
const root = ReactDOM.createRoot(node);
root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <React.StrictMode>
        <Suspense fallback={<></>}>
          <Order prod={prod} />
        </Suspense>
      </React.StrictMode>
    </PersistGate>
  </Provider>,
);

TabSwitcher(
  '.character__block ul',
  '.character__block ul li',
  '.reviews-min-block-js',
);

window.addEventListener('load', () => {
  const id = 'built-carousel';
  if (document.getElementById(id) === null) {
    return;
  }
  new Swiper(`#${id}`, {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: BUILT_SLID_BP,
    loop: true,
    navigation: {
      nextEl: '.completed-button-next',
      prevEl: '.completed-button-prev',
    },
  });
});

CallbackForm(['calc-ship'], 'Рассчитать доставку', 'calc_delivery', prod.id);
CallbackForm(['order-calc'], 'Заказать расчет', 'order_calc', prod.id);
CallbackForm(['order-sample'], 'Заказать образец', 'order_sample', prod.id);

trackFav();
trackCompare();

const shareUrl = window.location.href;
const items = document.getElementById('prod-share-items');
if (items !== null) {
  const hide = trackShare();
  const root = ReactDOM.createRoot(items);
  root.render(
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <React.StrictMode>
          <Suspense fallback={<></>}>
            <Share shareUrl={shareUrl} hide={hide} />
          </Suspense>
        </React.StrictMode>
      </PersistGate>
    </Provider>,
  );
}

let params = null;
const paramsNode = document.getElementById('all-params');
if (paramsNode !== null) {
  params = paramsNode.innerHTML;
}

const printNode = document.getElementById('print-prod');
const printRoot = ReactDOM.createRoot(printNode);
printRoot.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <React.StrictMode>
        <Suspense fallback={<></>}>
          <Print prod={prod} params={params} />
        </Suspense>
      </React.StrictMode>
    </PersistGate>
  </Provider>,
);

const headerFixedNode = document.getElementById('header-fixed-container');
const headerFixedRoot = ReactDOM.createRoot(headerFixedNode);
headerFixedRoot.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <React.StrictMode>
        <Suspense fallback={<></>}>
          <HeaderFixed prod={prod} shareUrl={shareUrl} />
        </Suspense>
      </React.StrictMode>
    </PersistGate>
  </Provider>,
);

extraProdsWithCategories(
  'related-prods',
  window.relatedProds,
  window.relatedProdCategories,
);
extraProds('similar-prods', window.similarProds);
extraProds('category-rand-prods', window.categoryRandProds);
